import { render, staticRenderFns } from "./WorkshopJob.vue?vue&type=template&id=324da28c&scoped=true&"
import script from "./WorkshopJob.vue?vue&type=script&lang=js&"
export * from "./WorkshopJob.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopJob.vue?vue&type=style&index=0&id=324da28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324da28c",
  null
  
)

export default component.exports